<div class="content-wrapper table-full-bx details-page">
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
                        
                        <div class="page-heading" *ngIf="recruiterUserId != undefined">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"> <a routerLink="/users"> Users </a> </li>
                                <li class="breadcrumb-item"> User Jobs </li>
                            </ol>
                        </div>
                        <div class="flexbox pageHeading">
                            <div class="iboxcontent">
                                <h3>My Jobs</h3>
                            </div>
                            <div class="input-group-icon input-group-icon-left ">
                                <div class="col-list-right">
                                    <form (ngSubmit)="searchFun()">
                                        <div class="form-group mb-0">
                                            <span class="input-icon input-icon-right font-16"><img
                                                    src="assets/images/search.svg"></span>
                                            <input type="text" [(ngModel)]="search" (ngModelChange)="searchFun()"
                                                autocomplete="off"
                                                class="form-control form-control-rounded form-control-solid"
                                                name="search" id="key-search" placeholder="Search by Job title" />
                                            <span *ngIf="search" class="closeSearch"
                                                (click)="clearSearch()">&times;</span>
                                            <ul *ngIf="allJobs?.length > 0" class="searchPannel">
                                                <li *ngFor="let item of allJobs">
                                                    {{item?.name}}
                                                </li>
                                            </ul>
                                        </div>
                                    </form>
                                </div>

                                <div class="col-list-right" *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER'">
                                    <a href="javascript:void(0)" (click)="reDirectTo()" class="commonBtn2"><img
                                            src="assets/images/ic_add_project.svg" class="ap"> Post A Job</a>
                                </div>

                                <div class="col-list-right"
                                    *ngIf="userDatas?.Recruiter?.userType != 'SUPER_RECRUITER' && userPermissionData?.createJob == 1">
                                    <a href="javascript:void(0)" class="commonBtn2" (click)="reDirectTo()"><img
                                            src="assets/images/ic_add_project.svg" class="ap"> Post A Job</a>
                                </div>

                            </div>
                        </div>
                        <!-- end -->
                        <!-- Table -->
                        <div class="table-wrapper table-scroll table-responsive mt-3">
                            <table id="example" class="table table-hover m-0 table-bordered" style="width:100%;">

                                <thead>
                                    <tr>
                                        <th>Job Id </th>
                                        <th>Job title</th>
                                        <!--  class="filter-set" -->
                                        <th>Post Date <a href="javascript:void(0);"
                                                (click)="setOrderBy('createdAt')"><img
                                                    src="assets/images/ic_filtter.svg" class="tableimg"> </a></th>
                                        <th>User </th>
                                        <th>Applicants </th>
                                        <th>Suggested candidates </th>
                                        <th>Status <a href="javascript:void(0);" (click)="setOrderBy('isBlocked')"><img
                                                    src="assets/images/ic_filtter.svg" class="tableimg"> </a></th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- 1 -->
                                    <tr
                                        *ngFor="let data of allJobs | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                                        <td><a href="javascript:void(0);" class="jobid"
                                                (click)="goToDetail(data)">{{data.newId}}</a></td>
                                        <td><a href="javascript:void(0);"
                                            (click)="goToDetail(data)">{{data.jobTitle}}</a></td>
                                        <td><a href="javascript:void(0);"
                                            (click)="goToDetail(data)">{{data.createdAt | date:
                                                "d/M/YYYY"}}</a></td>
                                        <td><a href="javascript:void(0);" (click)="goToDetail(data)">
                                                <span *ngIf="data.userType=='SUPER_RECRUITER'"
                                                    style="display: inline;">{{data?.recruiterName}}</span>
                                                <span *ngIf="data.userType=='SUB_RECRUITER'"
                                                    style="display: inline;">{{data?.subRecruiterName}}</span>
                                            </a></td>
                                        <td><a href="javascript:void(0);" class="jobid"
                                            (click)="goToDetail(data)">{{data.applicantsCount}}</a>
                                        </td>
                                        <td><a href="javascript:void(0);" class="jobid"
                                            (click)="goToSuggestedDetail(data)">{{data?.suggestedCandidateCount}}</a>
                                        </td>
                                        <td>
                                            <div ngbDropdown>
                                                <a class="jobid dropdown-toggle dropdownlist" href="javascript:void(0);"
                                                    data-toggle="dropdown" role="button" aria-haspopup="true"
                                                    aria-expanded="false" id="dropdown_profile_area" ngbDropdownToggle>
                                                    <span class="green"
                                                        *ngIf="data?.isBlocked == 0 && data?.isConfirm == 1">Open</span>
                                                    <span class="red"
                                                        *ngIf="data?.isBlocked == 1  && data?.isConfirm == 1">Closed</span>
                                                    <span class="red" *ngIf="data?.isConfirm == 0">Draft</span>
                                                    <img *ngIf="data?.isConfirm == 1" src="assets/images/ic_down.svg"
                                                        alt="down arrow"> </a>
                                                <ul class="dropdown-menu dropdown-menu-left dropdown-menu-animated dropdown-arrow "
                                                    ngbDropdownMenu *ngIf="data?.isConfirm == 1">
                                                    <li *ngIf="data?.isBlocked == 1"><a class="dropdown-item"
                                                            href="javascript:void(0);"
                                                            (click)="jobStatus($event,0,data.id)">Open</a></li>
                                                    <li *ngIf="data?.isBlocked == 0"><a class="dropdown-item"
                                                            href="javascript:void(0);"
                                                            (click)="openModal(data.id,jobCloseStatus)">Closed</a></li>
                                                </ul>
                                            </div>
                                        </td>

                                        <td>
                                            <div ngbDropdown>
                                                <a class="icon dropdown-toggle dropdownlist" href="javascript:void(0);"
                                                    data-toggle="dropdown" role="button" aria-haspopup="true"
                                                    aria-expanded="false" id="dropdown_profile_area"
                                                    ngbDropdownToggle><img src="assets/images/ic_three_dot.svg"></a>
                                                <ul class="dropdown-menu dropdown-menu-left dropdown-menu-animated dropdown-arrow "
                                                    ngbDropdownMenu>
                                                    <li *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER'"><a
                                                            class="dropdown-item" href="javascript:void(0);"
                                                            [routerLink]="'/jobs/edit/'"
                                                            [queryParams]="{jobId:data.id }">Edit</a></li>
                                                    <li
                                                        *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER' && userPermissionData?.editTeamMemberJob == 1">
                                                        <a class="dropdown-item" href="javascript:void(0);"
                                                            [routerLink]="'/jobs/edit/'"
                                                            [queryParams]="{jobId:data.id }">Edit</a></li>
                                                    <li><a class="dropdown-item" href="javascript:void(0);"
                                                            [routerLink]="'/jobs/template/'+data.id">Preview</a></li>
                                                    <li><a class="dropdown-item" href="javascript:void(0);"
                                                            (click)="jobStatus($event,0,data.id)"
                                                            *ngIf="data?.isBlocked == 1 && data?.isConfirm == 1">Open</a>
                                                    </li>
                                                    <li><a class="dropdown-item" href="javascript:void(0);"
                                                            (click)="openModal(data.id,jobCloseStatus)"
                                                            *ngIf="data?.isBlocked == 0 && data?.isConfirm == 1">Closed</a>
                                                    </li>
                                                    <li *ngIf="data?.isConfirm == 0"><a class="dropdown-item"
                                                            href="javascript:void(0);"
                                                            (click)="deleteStatus(data.id)">Discard</a></li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="noDataFound" *ngIf="allJobs == 0">
                                <h2>No records found</h2>
                            </div>
                        </div>
                        <!--  pagination  *ngIf="allJobs.length > 9" -->
                        <div class="col-sm-12 p-0" *ngIf="totalCount > 0">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)"
                                    previousText="&#60;" nextText="Next" firstText="&#62;"
                                    lastText="Last"></pagination-controls>
                            </ul>
                        </div>
                        <!-- end -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- End -->

<ng-template #jobCloseStatus>
    <div class="modal-body addModal text-left">
        <form [formGroup]="jobForm" (ngSubmit)="jobPostStatus()">
            <h4 class="uppercasetext">Are you sure you want to close this position?</h4>
            <div class="form-group">
                <label>Reason for closing job</label>
                <textarea class="form-control p-0" placeholder="Please write here" formControlName="reason"
                    maxlength="2000"></textarea>
                <p class="para5 text-left m-0">{{jobForm?.value?.reason?.length}}/2000</p>
                <div class="text-danger" *ngIf="jobForm.controls['reason'].hasError('required') && showError">
                    *Please Enter reason.
                </div>
            </div>
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isNotify"
                        [value]="1" [checked]="jobForm.value.isNotify == 1" (change)="jobForm.value.isNotify = 1">
                    <label class="custom-control-label" for="customCheckBox1">Do you want to notify users?</label>
                </div>
            </div>
            <div class="d-flex">

                <div class="form-group">
                    <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
                </div>
                <div class="form-group">
                    <input type="submit" value="Close position" class="planbtn fill">
                </div>

            </div>
        </form>
    </div>
</ng-template>